<template>
  <div id="page-user-list">
    <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8">
      <div class="vx-row">
        <div
          class="vx-col md:w-1/4 sm:w-1/2 w-full"
          v-if="actor.privilege <= 3"
        >
          <label class="text-sm opacity-75">Branch</label>
          <v-select
            :disabled="actor.privilege == 3"
            :options="branchList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.branch"
            class="mb-4 md:mb-0"
          />
        </div>
        <!-- <div
          class="vx-col md:w-1/4 sm:w-1/2 w-full"
          v-if="actor.privilege == 3"
        >
          <vs-input
            disabled
            label="Branch"
            class="w-full"
            :value="actor.ref_branch ? actor.ref_branch.name : '-'"
          />
        </div> -->

        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Gps Type</label>
          <v-select
            :options="gpsList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.gps_type"
            class="mb-4 md:mb-0"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Vehicle Type</label>
          <v-select
            :options="vehicleTypeList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.veh_type"
          />
        </div>
        <div v-if="actor.privilege < 6" class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Owner (Username)</label>
          <v-select
            @search="searchOwner"
            :options="ownerFilterList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.owner"
          />
        </div>
        <div v-else class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <vs-input
            disabled
            label="Owner"
            class="w-full"
            :value="actor.username"
          />
        </div>
        <div
          v-if="actor.privilege <= 2"
          class="vx-col md:w-1/4 sm:w-1/2 w-full"
        >
          <label class="text-sm opacity-75">Rebate For</label>
          <v-select
            :options="branchList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.rebate"
          />
        </div>
      </div>
    </vx-card>

    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <div class="flex flex-grow">
          <vs-button
            color="primary"
            type="gradient"
            class="mb-4 mr-2 md:mb-0"
            @click="add"
            >Add New Data</vs-button
          >
          <vs-button
            color="success"
            type="gradient"
            class="mb-4 mr-2 md:mb-0"
            @click="exportPopup = true"
            >Export Data</vs-button
          >
        </div>

        <vs-dropdown vs-trigger-click class="cursor-pointer mr-2">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ page * per_page - (per_page - 1) }} -
              {{
                row_total - page * per_page > 0 ? page * per_page : row_total
              }}
              of {{ row_total }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="updatePerPage(10)">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(25)">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(50)">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(100)">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>

        <v-select
          :options="searchableList"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          v-model="key_search"
          class="mr-2 sm:order-normal order-3 sm:mt-0 mt-4"
          style="width: 170px"
          :clearable="false"
        />

        <vs-input
          class="mr-2 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="keyword"
          placeholder="Search..."
          @keydown="(e) => search_proses(e)"
        />
        <!-- @keyup="search" -->

        <vs-button
          id="btnSearch"
          type="gradient"
          color="primary"
          class="p-2 vs-con-loading__container"
          size="large"
          icon="search"
          :disabled="loading"
          @click="search_proses()"
          ><span style="font-size: 16px">Search&nbsp;&nbsp;</span></vs-button
        >
      </div>

      <div class="table-container">
        <el-table
          :data="data"
          :sort-by="sort_by"
          border
          :height="data.length > 0 ? 600 : 110"
          style="
            width: 100%;
            margin-top: 10px;
            margin-bottom: 10px;
            border-left: 1px solid #ccc;
          "
        >
          <el-table-column
            label="No"
            type="index"
            width="60"
            :index="indexMethod"
            :key="1"
          >
          </el-table-column>
          <el-table-column label="Imei" sortable width="150" :key="2">
            <template slot-scope="scope">
              <div class="flex">
                <a href="javascript:;" @click="detail(scope.row.imei)">{{
                  scope.row.imei
                }}</a>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="serial_number"
            label="Serial Number"
            sortable
            width="140"
            v-if="actor.privilege <= 3"
            :key="3"
          >
          </el-table-column>
          <el-table-column
            prop="device_name"
            label="Device Name"
            sortable
            width="180"
            :key="4"
          >
          </el-table-column>
          <el-table-column
            prop="plate"
            label="Plate No"
            sortable
            width="180"
            :key="5"
          >
          </el-table-column>
          <el-table-column
            label="GSM No"
            sortable
            width="120"
            v-if="actor.privilege <= 4"
            :key="6"
          >
            <template slot-scope="scope">
              <div class="flex">
                {{ scope.row.gsm_no }} {{ scope.row.gsm_status2 }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="expired_gsm"
            label="Expired GSM"
            sortable
            width="150"
            v-if="actor.privilege <= 4"
            :key="7"
          >
            <template slot-scope="scope">
              <div class="flex">
                <table width="100%">
                  <tr>
                    <td>{{ scope.row.expired_gsm }}</td>
                    <!-- <td style="border-right: 2px solid #ccc">&nbsp;</td> -->
                    <td style="padding-left: 7px; float: right">
                      <center>
                        <vx-tooltip text="Synchronize" position="top">
                          <vs-button
                            :id="`syncBtn${scope.$index}`"
                            type="border"
                            size="small"
                            icon-pack="feather"
                            icon="icon-refresh-ccw"
                            color="warning"
                            class="mr-2 vs-con-loading__container"
                            @click="sync(scope.$index, scope.row.gsm_no)"
                          ></vs-button>
                        </vx-tooltip>
                      </center>
                    </td>
                  </tr>
                </table>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="register_date"
            label="Register Date"
            sortable
            width="140"
            v-if="actor.privilege <= 4"
            :key="8"
          >
          </el-table-column>

          <el-table-column label="GPS Type" width="130" :key="9">
            <template slot-scope="scope">
              <!-- <div class="flex">
                {{ scope.row._gps_type ? scope.row._gps_type.name : '-' }}
              </div> -->
              <div class="flex">
                <table width="100%">
                  <tr>
                    <td>
                      {{ scope.row._gps_type ? scope.row._gps_type.name : '-' }}
                    </td>
                    <td
                      v-if="
                        scope.row._gps_type &&
                        scope.row._gps_type.code == 'dashcam'
                      "
                      style="padding-left: 7px; float: right"
                    >
                      <center>
                        <vx-tooltip text="Set Watermark" position="top">
                          <vs-button
                            :id="`setWtrBtn${scope.$index}`"
                            type="border"
                            size="small"
                            icon-pack="feather"
                            icon="icon-link-2"
                            color="warning"
                            class="mr-2 vs-con-loading__container"
                            @click="
                              setWatermark(
                                scope.$index,
                                scope.row.imei,
                                scope.row.plate
                              )
                            "
                          ></vs-button>
                        </vx-tooltip>
                      </center>
                    </td>
                  </tr>
                </table>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="LT Warranty" width="130" :key="10">
            <template slot-scope="scope">
              <div class="flex">
                {{
                  scope.row.lifetime_warranty == 0
                    ? 'Not Active'
                    : scope.row.lifetime_warranty == 1
                    ? 'Active'
                    : 'Not Available'
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Owner" width="180" :key="11">
            <template slot-scope="scope">
              <div class="flex">
                {{ scope.row._owner ? scope.row._owner.username : '-' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="branch_name"
            label="Branch"
            width="180"
            v-if="actor.privilege <= 3"
            :key="12"
          >
          </el-table-column>
          <el-table-column
            label="Rebate"
            width="180"
            v-if="actor.privilege <= 3"
            :key="13"
          >
            <template slot-scope="scope">
              <div class="flex">
                {{ scope.row._rebate_for ? scope.row._rebate_for.name : '-' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="kir" label="Expired KIR" width="120" :key="14">
          </el-table-column>
          <el-table-column
            prop="stnk"
            label="Expired STNK"
            width="120"
            :key="15"
          >
          </el-table-column>

          <!-- =========== BUTTON IN VIEW WEB ============== -->
          <el-table-column
            v-if="!isSmallerScreen"
            :key="16"
            label="Action"
            fit
            fixed="right"
            :min-width="
              actor.privilege == 1
                ? '260'
                : actor.privilege == 2
                ? '225'
                : actor.privilege == 3
                ? '155'
                : '100'
            "
          >
            <template slot-scope="scope">
              <div class="flex" v-if="!scope.row.is_shared">
                <vx-tooltip
                  v-if="actor.privilege >= 4"
                  text="Share Location"
                  position="top"
                >
                  <vs-button
                    :id="`shareBtn${scope.row.imei}`"
                    type="border"
                    size="small"
                    icon-pack="feather"
                    icon="icon-share-2"
                    color="primary"
                    class="mr-2 vs-con-loading__container"
                    @click="share(scope.row.imei)"
                  ></vs-button>
                </vx-tooltip>
                <vx-tooltip text="Edit" position="top">
                  <vs-button
                    :id="`editBtn${scope.row.imei}`"
                    type="border"
                    size="small"
                    icon-pack="feather"
                    icon="icon-edit"
                    color="success"
                    class="mr-2 vs-con-loading__container"
                    @click="edit(scope.row.imei)"
                  ></vs-button>
                </vx-tooltip>
                <vx-tooltip
                  v-if="actor.privilege <= 3"
                  text="Swap Simcard"
                  position="top"
                >
                  <vs-button
                    type="border"
                    size="small"
                    icon-pack="feather"
                    icon="icon-repeat"
                    color="warning"
                    class="mr-2"
                    @click="swapGsm(scope.row)"
                  ></vs-button>
                </vx-tooltip>
                <vx-tooltip
                  v-if="actor.privilege <= 3"
                  text="Change Unit"
                  position="top"
                >
                  <vs-button
                    :id="`changeUnitBtn${scope.row.imei}`"
                    type="border"
                    size="small"
                    icon-pack="feather"
                    icon="icon-refresh-cw"
                    color="primary"
                    class="mr-2 vs-con-loading__container"
                    @click="change_unit(scope.row.imei)"
                  ></vs-button>
                </vx-tooltip>
                <vx-tooltip
                  v-if="actor.privilege == 1 || actor.sp_access == 1"
                  text="Delete"
                  position="top"
                >
                  <vs-button
                    type="border"
                    size="small"
                    icon-pack="feather"
                    icon="icon-trash"
                    color="danger"
                    class="mr-2 vs-con-loading__container"
                    @click="del(scope.row.imei)"
                  ></vs-button>
                </vx-tooltip>
                <vx-tooltip
                  v-if="actor.privilege <= 2"
                  text="Reset Mileage"
                  position="top"
                >
                  <vs-button
                    type="border"
                    size="small"
                    icon-pack="feather"
                    icon="icon-rotate-ccw"
                    color="dark"
                    class="mr-2 vs-con-loading__container"
                    @click="reset_mileage(scope.row.imei, scope.row.mileage)"
                  ></vs-button>
                </vx-tooltip>
                <vx-tooltip
                  v-if="actor.privilege == 1 || is_limit_access"
                  text="Setup Limit Camera"
                  position="top"
                >
                  <vs-button
                    type="border"
                    class="mr-2 vs-con-loading__container"
                    size="small"
                    icon-pack="feather"
                    icon="icon-clock"
                    color="success"
                    :id="`limitCameraBtn_${scope.$index}`"
                    @click="
                      ;(activePromptLimitCamera = true),
                        limit_camera(scope.row, scope.$index)
                    "
                  ></vs-button>
                </vx-tooltip>
                <vx-tooltip
                  v-if="actor.privilege <= 3"
                  text="Update Total Camera"
                  position="top"
                >
                  <vs-button
                    type="border"
                    class="mr-2 vs-con-loading__container"
                    size="small"
                    icon-pack="feather"
                    icon="icon-video"
                    color="warning"
                    :id="`totalCameraBtn_${scope.$index}`"
                    @click="
                      ;(activePromptTotalCamera = true),
                        total_camera(scope.row, scope.$index)
                    "
                  ></vs-button>
                </vx-tooltip>
              </div>

              <div class="flex" v-else>
                <vx-tooltip
                  v-if="actor.privilege >= 4"
                  text="Share Location"
                  position="top"
                >
                  <vs-button
                    :id="`shareBtn${scope.row.imei}`"
                    type="border"
                    size="small"
                    icon-pack="feather"
                    icon="icon-share-2"
                    color="primary"
                    class="mr-2 vs-con-loading__container"
                    @click="share(scope.row.imei)"
                  ></vs-button>
                </vx-tooltip>
              </div>
            </template>
          </el-table-column>

          <!-- ============= BUTTON IN VIEW MOBILE =============== -->
          <el-table-column
            v-else
            :key="16"
            label="Action"
            fit
            :min-width="
              actor.privilege == 1
                ? '260'
                : actor.privilege == 2
                ? '225'
                : actor.privilege == 3
                ? '155'
                : '100'
            "
          >
            <template slot-scope="scope">
              <div class="flex" v-if="!scope.row.is_shared">
                <vx-tooltip
                  v-if="actor.privilege >= 4"
                  text="Share Location"
                  position="top"
                >
                  <vs-button
                    :id="`shareBtn${scope.row.imei}`"
                    type="border"
                    size="small"
                    icon-pack="feather"
                    icon="icon-share-2"
                    color="primary"
                    class="mr-2 vs-con-loading__container"
                    @click="share(scope.row.imei)"
                  ></vs-button>
                </vx-tooltip>
                <vx-tooltip text="Edit" position="top">
                  <vs-button
                    :id="`editBtn${scope.row.imei}`"
                    type="border"
                    size="small"
                    icon-pack="feather"
                    icon="icon-edit"
                    color="success"
                    class="mr-2 vs-con-loading__container"
                    @click="edit(scope.row.imei)"
                  ></vs-button>
                </vx-tooltip>
                <vx-tooltip
                  v-if="actor.privilege <= 3"
                  text="Swap Simcard"
                  position="top"
                >
                  <vs-button
                    type="border"
                    size="small"
                    icon-pack="feather"
                    icon="icon-repeat"
                    color="warning"
                    class="mr-2"
                    @click="swapGsm(scope.row)"
                  ></vs-button>
                </vx-tooltip>
                <vx-tooltip
                  v-if="actor.privilege <= 3"
                  text="Change Unit"
                  position="top"
                >
                  <vs-button
                    :id="`changeUnitBtn${scope.row.imei}`"
                    type="border"
                    size="small"
                    icon-pack="feather"
                    icon="icon-refresh-cw"
                    color="primary"
                    class="mr-2 vs-con-loading__container"
                    @click="change_unit(scope.row.imei)"
                  ></vs-button>
                </vx-tooltip>
                <vx-tooltip
                  v-if="actor.privilege == 1 || actor.sp_access == 1"
                  text="Delete"
                  position="top"
                >
                  <vs-button
                    type="border"
                    size="small"
                    icon-pack="feather"
                    icon="icon-trash"
                    color="danger"
                    class="mr-2 vs-con-loading__container"
                    @click="del(scope.row.imei)"
                  ></vs-button>
                </vx-tooltip>
                <vx-tooltip
                  v-if="actor.privilege <= 2"
                  text="Reset Mileage"
                  position="top"
                >
                  <vs-button
                    type="border"
                    size="small"
                    icon-pack="feather"
                    icon="icon-rotate-ccw"
                    color="dark"
                    class="mr-2 vs-con-loading__container"
                    @click="reset_mileage(scope.row.imei, scope.row.mileage)"
                  ></vs-button>
                </vx-tooltip>
                <vx-tooltip
                  v-if="actor.privilege == 1 || is_limit_access"
                  text="Setup Limit Camera"
                  position="top"
                >
                  <vs-button
                    type="border"
                    class="mr-2 vs-con-loading__container"
                    size="small"
                    icon-pack="feather"
                    icon="icon-clock"
                    color="success"
                    :id="`limitCameraBtn_${scope.$index}`"
                    @click="
                      ;(activePromptLimitCamera = true),
                        limit_camera(scope.row, scope.$index)
                    "
                  ></vs-button>
                </vx-tooltip>
                <vx-tooltip
                  v-if="actor.privilege <= 2"
                  text="Update Total Camera"
                  position="top"
                >
                  <vs-button
                    type="border"
                    class="mr-2 vs-con-loading__container"
                    size="small"
                    icon-pack="feather"
                    icon="icon-video"
                    color="warning"
                    :id="`totalCameraBtn_${scope.$index}`"
                    @click="
                      ;(activePromptTotalCamera = true),
                        total_camera(scope.row, scope.$index)
                    "
                  ></vs-button>
                </vx-tooltip>
              </div>

              <div class="flex" v-else>
                <vx-tooltip
                  v-if="actor.privilege >= 4"
                  text="Share Location"
                  position="top"
                >
                  <vs-button
                    :id="`shareBtn${scope.row.imei}`"
                    type="border"
                    size="small"
                    icon-pack="feather"
                    icon="icon-share-2"
                    color="primary"
                    class="mr-2 vs-con-loading__container"
                    @click="share(scope.row.imei)"
                  ></vs-button>
                </vx-tooltip>
              </div>
            </template>
          </el-table-column>

          <div
            slot="append"
            v-if="data.length < 1 || loading"
            class="table_empty"
          >
            {{ loading ? 'Loading....' : 'No Data Available' }}
          </div>
        </el-table>
        <vs-pagination :total="n_page" v-model="page" goto></vs-pagination>
      </div>

      <vs-popup
        classContent="popup-example"
        :title="popupTitle"
        :active.sync="showPopup"
      >
        <template>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-1/2 w-full required">
              <vs-input
                :disabled="action !== 'add'"
                label="Imei"
                class="w-full"
                v-model="input.imei"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full required">
              <vs-input
                :disabled="action === 'detail'"
                label="Device name"
                class="w-full"
                v-model="input.device_name"
              />
            </div>
          </div>
          <div class="vx-row">
            <div
              v-if="action == 'edit'"
              class="vx-col sm:w-1/2 w-full required"
            >
              <label class="vs-input--label mb-2">Plate</label>
              <vx-input-group class="mb-base">
                <vs-input v-model="input.plate" :disabled="!isChangePlate" />

                <template slot="append">
                  <div class="append-text btn-addon">
                    <vs-button
                      id="ChangePlatebtn"
                      @click="ChangePlate"
                      :color="isChangePlate ? 'danger' : 'primary'"
                      type="border"
                      icon-pack="feather"
                      :icon="isChangePlate ? 'icon-x' : 'icon-edit'"
                    ></vs-button>
                  </div>
                </template>
              </vx-input-group>
            </div>
            <div v-else class="vx-col sm:w-1/2 w-full required">
              <vs-input
                :disabled="action === 'detail'"
                label="Plate"
                class="w-full"
                v-model="input.plate"
              />
            </div>
            <div
              v-if="action === 'edit'"
              class="vx-col sm:w-1/2 w-full required"
            >
              <label class="vs-input--label mb-2">Gsm No</label>
              <vx-input-group v-if="actor.privilege <= 3" class="mb-base">
                <vs-input v-model="input.gsm_no" :disabled="!isChangeGsm" />

                <template slot="append">
                  <div class="append-text btn-addon">
                    <vs-button
                      id="ChangeGsmBtn"
                      @click="ChangeGsm"
                      :color="isChangeGsm ? 'danger' : 'primary'"
                      type="border"
                      icon-pack="feather"
                      :icon="isChangeGsm ? 'icon-x' : 'icon-edit'"
                    ></vs-button>
                  </div>
                </template>
              </vx-input-group>

              <vs-input v-else v-model="input.gsm_no" class="w-full" disabled />
            </div>
            <div v-else class="vx-col sm:w-1/2 w-full required">
              <vs-input
                :disabled="action === 'detail'"
                label="Gsm Number"
                class="w-full"
                v-model="input.gsm_no"
              />
            </div>
          </div>
          <div v-show="isChangePlate" class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-textarea
                label="Description Change Plate"
                class="w-full"
                rows="3"
                v-model="input.descriptionPlate"
              />
            </div>
          </div>

          <div v-show="isChangeGsm" class="vx-row mb-3">
            <div class="vx-col w-full">
              <ul class="centerx simcard-radio">
                <li>
                  <vs-radio v-model="input.simcard_change_type" vs-value="paid"
                    >Paid</vs-radio
                  >
                </li>
                <li>
                  <vs-radio v-model="input.simcard_change_type" vs-value="free"
                    >Free</vs-radio
                  >
                </li>
              </ul>
            </div>
          </div>

          <div v-show="isChangeGsm" class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-textarea
                label="Description Change Gsm"
                class="w-full"
                rows="3"
                v-model="input.descriptionGsm"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-1/2 w-full required">
              <label class="vs-input--label">Vehicle Type</label>
              <v-select
                :disabled="action === 'detail'"
                :clearable="false"
                :options="vehicleTypeList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="w-full"
                v-model="input.veh_type"
              />
            </div>
            <div
              v-if="action !== 'detail'"
              class="vx-col sm:w-1/2 w-full required"
            >
              <label class="vs-input--label mb-2">Icon</label>
              <v-select
                :disabled="action === 'detail'"
                :options="iconList"
                v-model="input.icon"
              >
                <template slot="option" slot-scope="option">
                  <img
                    style="width: 50px; height: 50px"
                    :src="option.parking"
                  />
                  <img style="width: 50px; height: 50px" :src="option.acc_on" />
                  <img style="width: 50px; height: 50px" :src="option.lost" />
                  <img style="width: 50px; height: 50px" :src="option.alarm" />
                </template>
              </v-select>
            </div>
            <div v-else class="vx-col sm:w-1/2 w-full required">
              <label class="vs-input--label mb-2">Icon</label>
              <div class="pl-3">
                <img
                  class="mr-2"
                  style="width: 50px; height: 50px"
                  :src="input.icon.parking"
                />
                <img
                  class="mr-2"
                  style="width: 50px; height: 50px"
                  :src="input.icon.acc_on"
                />
                <img
                  class="mr-2"
                  style="width: 50px; height: 50px"
                  :src="input.icon.lost"
                />
                <img
                  class="mr-2"
                  style="width: 50px; height: 50px"
                  :src="input.icon.alarm"
                />
              </div>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col sm:w-1/2 w-full required">
              <label class="vs-input--label">Vehicle Brand</label>
              <v-select
                :disabled="action === 'detail'"
                :clearable="false"
                :options="vehicleBrandList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="w-full"
                v-model="input.veh_brand"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full required">
              <label class="vs-input--label">Vehicle List</label>
              <v-select
                :disabled="action === 'detail'"
                :clearable="false"
                :options="vehicleList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="w-full"
                v-model="input.veh_list"
              />
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col sm:w-1/2 w-full required">
              <label class="vs-input--label">Branch</label>
              <v-select
                :disabled="
                  action === 'detail' ||
                  (actor.privilege >= 2 && actor.sp_access != 1) ||
                  (actor.privilege >= 2 && action == 'add')
                "
                :clearable="false"
                :options="branchList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="w-full"
                v-model="input.branch"
              />
            </div>
            <!-- <div v-else class="vx-col sm:w-1/2 w-full required">
              <vs-input disabled label="Branch" class="w-full" v-model="actor.ref_branch.name" />
            </div> -->
            <div class="vx-col sm:w-1/2 w-full required">
              <label class="vs-input--label">Owner</label>
              <v-select
                :disabled="action === 'detail'"
                :clearable="false"
                :options="ownerList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="w-full"
                v-model="input.owner"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div
              :class="
                action === 'add'
                  ? 'vx-col sm:w-1/2 w-full required'
                  : 'vx-col sm:w-1/2 w-full'
              "
            >
              <label class="vs-input--label">Installer (Technician)</label>
              <v-select
                :disabled="action === 'detail'"
                :clearable="false"
                :options="technicianList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="w-full"
                v-model="input.technician"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full required">
              <vs-input
                :disabled="action === 'detail'"
                label="Production Year"
                class="w-full"
                v-model="input.year"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div v-if="action === 'detail'" class="vx-col sm:w-1/2 w-full">
              <vs-input
                :disabled="action === 'detail'"
                label="Expired STNK"
                class="w-full"
                v-model="input.stnk"
              />
            </div>
            <div v-else class="vx-col sm:w-1/2 w-full">
              <label class="vs-input--label">Expired STNK</label>
              <template>
                <flat-pickr
                  :disabled="action === 'detail'"
                  label="Expired STNK"
                  class="w-full"
                  v-model="input.stnk"
                />
              </template>
            </div>
            <div v-if="action === 'detail'" class="vx-col sm:w-1/2 w-full">
              <vs-input
                :disabled="action === 'detail'"
                label="Expired KIR"
                class="w-full"
                v-model="input.kir"
              />
            </div>
            <div v-else class="vx-col sm:w-1/2 w-full">
              <label class="vs-input--label">Expired KIR</label>
              <template>
                <flat-pickr
                  :disabled="action === 'detail'"
                  label="Expired KIR"
                  class="w-full"
                  v-model="input.kir"
                />
              </template>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                :disabled="action === 'detail'"
                label="Engine Number"
                class="w-full"
                v-model="input.nomesin"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                :disabled="action === 'detail'"
                label="Chasis Number"
                class="w-full"
                v-model="input.norangka"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                :disabled="action === 'detail'"
                label="Speed Limit (Km/H)"
                class="w-full"
                v-model="input.speed_limit"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <label class="vs-input--label">Sales</label>
              <v-select
                :disabled="
                  action === 'detail' ||
                  (action == 'edit' && actor.privilege != 1)
                "
                :clearable="false"
                :options="salesList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="w-full"
                v-model="input.sales_id"
              />
            </div>
          </div>
          <div v-show="action === 'detail'" class="vx-row mb-6">
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                :disabled="action === 'detail'"
                label="Battery Status"
                class="w-full"
                v-model="input.battery"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                :disabled="action === 'detail'"
                label="GSM Signal"
                class="w-full"
                v-model="input.gsm_signal"
              />
            </div>
          </div>
          <div v-show="action === 'detail'" class="vx-row mb-6">
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                :disabled="action === 'detail'"
                label="Expired GSM"
                class="w-full"
                v-model="input.expired_date"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                :disabled="action === 'detail'"
                label="Register Date"
                class="w-full"
                v-model="input.register_date"
              />
            </div>
          </div>
          <div v-show="action === 'detail'" class="vx-row mb-6">
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                disabled
                label="Warranty"
                class="w-full"
                :value="
                  input.lifetime_warranty === 1 ? 'Lifetime' : input.guarantee
                "
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                disabled
                label="Lifetime Warranty"
                class="w-full"
                :style="input.lifetimw_warranty === 0 ? `color:red` : ``"
                :value="
                  input.lifetime_warranty === 1
                    ? 'Active'
                    : input.lifetime_warranty === 0
                    ? 'Not Active'
                    : 'Not Available'
                "
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                :disabled="action === 'detail'"
                label="Driver Name"
                class="w-full"
                v-model="input.driver_name"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                :disabled="action === 'detail'"
                label="Note"
                class="w-full"
                v-model="input.note"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                :disabled="action === 'detail'"
                v-show="action === 'detail' && input.gps_code === 'dashcam'"
                label="Limit Streaming"
                class="w-full"
                v-model="input.limit_stream"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                :disabled="action === 'detail'"
                v-show="action === 'detail' && input.gps_code === 'dashcam'"
                label="Total Camera"
                class="w-full"
                v-model="input.total_camera"
              />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full ml-auto">
              <vs-button
                :disabled="loading"
                v-if="action !== 'detail'"
                id="submitBtn"
                class="mr-3 mb-2 vs-con-loading__container"
                @click="submit"
                >Submit</vs-button
              >
              <vs-button
                :disabled="loading"
                v-show="action === 'add'"
                color="warning"
                type="border"
                @click="reset"
                class="mb-2"
                >Reset</vs-button
              >
            </div>
          </div>
        </template>
      </vs-popup>

      <vs-popup
        classContent="popup-example"
        title="Change Unit"
        :active.sync="changeUnitPopup"
      >
        <template>
          <div class="vx-row mb-3">
            <div class="vx-col w-full required">
              <label class="vs-input--label">Type</label>
              <v-select
                :clearable="false"
                :options="[
                  { value: 0, label: 'Warranty Claim' },
                  { value: 1, label: 'Trade In' }
                ]"
                class="w-full"
                v-model="input.type"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-1/2 w-full required">
              <vs-input
                disabled
                label="Imei"
                class="w-full"
                v-model="input.imei"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full required">
              <vs-input
                label="New Imei"
                class="w-full"
                v-model="input.new_imei"
              />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-textarea
                required
                label="Description"
                class="w-full"
                rows="3"
                v-model="input.description"
              />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full ml-auto">
              <vs-button
                id="submitBtnChangeUnit"
                :disabled="isSubmit"
                class="mr-3 mb-2 vs-con-loading__container"
                @click="submitChangeUnit"
                >Submit</vs-button
              >
            </div>
          </div>
        </template>
      </vs-popup>

      <vs-popup
        classContent="popup-example"
        title="Share Location"
        :active.sync="shareLocPopup"
      >
        <template>
          <div class="vx-row mb-3">
            <div class="vx-col w-full required">
              <vs-input
                :disabled="isShare"
                label="Title"
                class="w-full"
                v-model="shareData.name"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-1/2 w-full">
              <label class="vs-input--label">Email</label>
              <tags-input
                element-id="tags"
                placeholder="Type an email and press enter"
                v-model="shareData.email"
                :typeahead="true"
              ></tags-input>
            </div>
            <div class="vx-col sm:w-1/2 w-full required">
              <label class="vs-input--label">Time Duration</label>
              <v-select
                :disabled="isShare"
                :clearable="false"
                :options="timeList"
                class="w-full"
                v-model="shareData.time"
              />
            </div>
          </div>
          <div v-if="isShare" class="vx-row mb-6">
            <div class="vx-col w-full sm:w-1/2 required">
              <vs-input
                label="Whatsapp Number"
                class="w-full"
                v-model="shareData.phone"
              />
            </div>
            <div class="vx-col w-full sm:w-1/2">
              <vs-button
                :disabled="!shareData.phone"
                type="border"
                color="success"
                id="createLink"
                class="mr-3 mb-2 mt-5 vs-con-loading__container"
                @click="shareWA"
                >Whatsapp <img src="whatsapp.png" width="13px" alt=""
              /></vs-button>
            </div>
          </div>
          <div class="vx-row mt-3">
            <div class="vx-col w-full ml-auto">
              <vs-button
                :disabled="isShare"
                id="createLink"
                class="mr-3 mb-2 vs-con-loading__container"
                @click="shareLoc"
                >Create Link</vs-button
              >
            </div>
          </div>
        </template>
      </vs-popup>

      <vs-popup
        classContent="popup-example"
        title="Export Vehicle List"
        :active.sync="exportPopup"
      >
        <template>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <label class="vs-input--label">Owner (Username)</label>
              <v-select
                :clearable="false"
                @search="searchOwner"
                :options="ownerFilterList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="w-full"
                v-model="exportData.username"
              />
              <label class="vs-input--label"
                >*Note: Exported data is include all Sub User's vehicle of
                Selected Owner</label
              >
            </div>
            <div class="vx-col w-full mt-5" v-if="actor.privilege == 3">
              <vs-checkbox v-model="export_all">
                <label for="">Export All Vehicle</label>
              </vs-checkbox>
              <label class="vs-input--label"
                >*Note: Checked to export all the vehicle</label
              >
            </div>
          </div>
          <div class="vx-row mt-3">
            <div class="vx-col w-full ml-auto">
              <vs-button
                :disabled="exportLoading"
                id="exportBtn"
                class="mr-3 mb-2 vs-con-loading__container"
                @click="doExport"
                >Export</vs-button
              >
            </div>
          </div>
        </template>
      </vs-popup>

      <vs-popup
        classContent="popup-example"
        title="Swap Simcard"
        :active.sync="swapSimcardPopup"
      >
        <template>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-input
                label="From"
                class="w-full"
                :disabled="true"
                v-model="swapData.text"
              />
            </div>
            <div class="vx-col w-full">
              <label class="text-sm opacity-75">Swap With</label>
              <v-select
                @search="searchTarget"
                :options="swapTargetList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="swapData.target_imei"
              />
            </div>
          </div>
          <div class="vx-row mt-3">
            <div class="vx-col w-full ml-auto">
              <vs-button
                :disabled="swapLoading"
                id="swapBtn"
                class="mr-3 mb-2 vs-con-loading__container"
                @click="doSwap"
                >Swap</vs-button
              >
            </div>
          </div>
        </template>
      </vs-popup>

      <vs-popup
        classContent="popup-example"
        title="Reset Mileage"
        :active.sync="resetMileagePopup"
      >
        <template>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-input
                label="Mileage Before"
                class="w-full"
                v-model="resetMileageData.mileage_before"
                :disabled="true"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-input
                label="New Mileage"
                class="w-full"
                v-model="resetMileageData.mileage"
              />
            </div>
          </div>
          <div class="vx-row mt-3">
            <div class="vx-col w-full ml-auto">
              <vs-button
                :disabled="resetLoading"
                id="resetMileage"
                class="mr-3 mb-2 vs-con-loading__container"
                @click="act_reset_mileage"
                >Reset Mileage</vs-button
              >
            </div>
          </div>
        </template>
      </vs-popup>
    </div>

    <vs-prompt
      title="Setup Limit Camera"
      color="success"
      @accept="confirmLimitCamera"
      :active.sync="activePromptLimitCamera"
    >
      <div class="con-exemple-prompt">
        <label class="text-sm opacity-75">Limit Live Camera</label>
        <v-select
          :options="limitCameraList"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          v-model="selected_limit"
          class="mb-4 md:mb-0"
        />
      </div>
    </vs-prompt>

    <vs-prompt
      title="Update Total Camera"
      color="warning"
      @accept="confirmTotalCamera"
      :active.sync="activePromptTotalCamera"
    >
      <div class="con-exemple-prompt">
        <label class="text-sm opacity-75">Total Camera Dashcam</label>
        <v-select
          :options="totalCameraList"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          v-model="selected_total_camera"
          class="mb-4 md:mb-0"
        />
      </div>
    </vs-prompt>
  </div>
</template>

<style>
[dir] .v-select .vs__dropdown-toggle {
  height: 43px;
}

[dir='ltr'] .el-table .cell {
  padding-left: 10px;
  padding-right: 10px;
}

.el-table thead {
  color: #ffff;
  font-weight: bold;
}

[dir] .el-table--border::after,
[dir] .el-table--group::after,
[dir] .el-table::before {
  background-color: #ccc;
}

[dir] .el-table th.el-table__cell {
  background-color: #eee;
  font-size: 12px;
  color: #626262;
}

[dir] .el-table td.el-table__cell {
  font-size: 12px;
}

[dir] .el-table tr:active .el-table__cell {
  background-color: rgb(198, 198, 198);
}

[dir] .el-table td.el-table__cell,
[dir] .el-table th.el-table__cell.is-leaf {
  border-bottom: 1px solid #ccc;
}

[dir] .el-table .ascending .sort-caret.ascending {
  border-bottom-color: #ffff;
}

[dir] .el-table .descending .sort-caret.descending {
  border-top-color: #ffff;
}

.el-table--border .el-table__cell,
[dir='ltr']
  .el-table__body-wrapper
  .el-table--border.is-scrolling-left
  ~ .el-table__fixed {
  border-left: 1px solid #ccc;
  border-top: 1px solid #ccc;
}

[dir] .el-table .el-table__cell {
  padding: 7px 0;
}

.el-table__empty-block {
  display: none !important;
}

.table_empty {
  text-align: center;
  font-size: 13px;
  padding: 10px;
  border-left: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}

.table_total {
  padding: 10px;
  border: 1px solid #ccc;
  margin-bottom: 10px;
}
</style>

<script>
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import FileDownload from 'js-file-download'

export default {
  components: {
    vSelect,
    flatPickr
  },

  data() {
    return {
      data: [],
      actor: {},
      token: '',
      showPopup: false,
      popupTitle: '',
      action: '',
      isSubmit: false,

      changeUnitPopup: false,
      shareLocPopup: false,
      swapSimcardPopup: false,
      resetMileagePopup: false,

      tempId: 0,
      loading: false,

      tempOwner: '',
      tempTechnician: '',
      tempSales: '',
      tempIcon: '',

      isShare: false,

      input: {
        imei: '',
        branch: '',
        technician: '',
        owner: '',
        gsm_no: '',
        plate: '',
        gps_type: '',
        veh_type: '',
        icon: '',
        year: '',
        nomesin: '',
        norangka: '',
        guarantee: null,
        stnk: null,
        kir: null,
        speed_limit: '',
        sales_id: '',
        device_name: '',
        gsm_signal: 0,
        battery: 0,
        expired_date: null,
        register_date: '',
        simcard_change_type: 'paid',
        lifetime_warranty: '',
        driver_name: '',

        new_imei: '',
        description: '',
        type: null,
        descriptionGsm: '',
        descriptionPlate: '',

        veh_brand: '',
        veh_list: '',
        note: '',
        limit_stream: '',
        gps_code: '',
        total_camera: ''
      },

      shareData: {
        name: '',
        email: [],
        time: '',
        url: ''
      },

      swapData: {
        imei: '',
        text: '',
        target_imei: ''
      },

      resetMileageData: {
        imei: '',
        mileage_before: '',
        mileage: ''
      },

      timeList: [
        { value: 60, label: '1 Hour' },
        { value: 180, label: '3 Hours' },
        { value: 360, label: '6 Hours' },
        { value: 720, label: '12 Hours' },
        { value: 1440, label: '24 Hours' }
      ],

      gpsList: [],
      vehicleTypeList: [],
      ownerList: [],
      branchList: [],
      technicianList: [],
      salesList: [],
      ownerFilterList: [],
      iconList: [],
      swapTargetList: [],

      filter: {
        branch: '',
        veh_type: '',
        gps_type: '',
        owner: '',
        rebate: ''
      },

      page: 1,
      per_page: 10,
      row_total: 0,
      keyword: '',

      timer: null,
      notify: 'Server Error',

      isChangeGsm: false,
      isChangePlate: false,

      exportPopup: false,
      exportLoading: false,
      ownerExportList: [],
      exportData: {
        username: null
      },

      swapLoading: false,
      resetLoading: false,

      timer: null,
      lt_warranty: ['Not Active', 'Active', 'Not Availabe'],
      vehicleBrandList: [],
      vehicleList: [],
      export_all: false,

      sort_by:
        ({ prop: 'imei', order: 'descending' },
        { prop: 'serial_number', order: 'descending' },
        { prop: 'device_name', order: 'descending' },
        { prop: 'plate', order: 'descending' },
        { prop: 'gsm_no', order: 'descending' },
        { prop: 'expired_gsm', order: 'descending' },
        { prop: 'register_date', order: 'descending' }),

      client_ip: '',

      limitCameraList: '',
      activePromptLimitCamera: false,
      imei_limit: '',
      imei_index_limit: '',
      selected_limit: {},

      totalCameraList: [
        { value: 1, label: '1 Camera' },
        { value: 2, label: '2 Camera' }
      ],
      activePromptTotalCamera: false,
      imei_total_camera: '',
      imei_index_total_camera: '',
      selected_total_camera: {},

      searchableList: [
        { value: 'imei', label: 'Imei' },
        { value: 'plate', label: 'Plate No' },
        { value: 'device_name', label: 'Device Name' },
        { value: 'gsm_no', label: 'GSM No' }
      ],
      key_search: { value: 'imei', label: 'Imei' },
      block_cabang: true,
      user_special_limit_access: ['ernald', 'adminss'],
      is_limit_access: false
    }
  },

  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 992
    },

    n_page() {
      return Math.ceil(this.row_total / this.per_page)
    },

    branch() {
      return this.input.branch ? this.input.branch.value : ''
    },

    filterBranch() {
      return this.filter.branch ? this.filter.branch.value : ''
    },

    veh_type() {
      return this.input.veh_type ? this.input.veh_type.value : ''
    },

    veh_brand() {
      return this.input.veh_brand ? this.input.veh_brand.value : ''
    },

    image_source() {
      return `${this.$api.base_url}/uploads/icon`
    },

    filterRebate() {
      return this.filter.rebate ? this.filter.rebate.value : ''
    }

    // plate() {
    //   return this.input.plate
    // }
  },

  watch: {
    page() {
      this.loading = true
      this.initTable()
    },

    per_page() {
      if (this.page != 1) this.page = 1
      else this.initTable()
    },

    branch() {
      if (this.branch !== '') {
        this.getOwnerList()
        this.getTechnicianList()
        this.getSalesList()
      }
    },

    filter: {
      handler(val) {
        this.page = 1
        if (this.block_cabang && this.actor.privilege == 3) {
          this.block_cabang = false
          return false
        }

        this.initTable()
      },
      deep: true
    },

    filterBranch() {
      this.filter.owner = ''
    },

    veh_type() {
      if (this.veh_type !== '') {
        this.input.icon = ''
        this.input.veh_list = ''
        this.getVehicleIcon()
        this.getVehicleList()
      }
    },

    veh_brand() {
      if (this.veh_brand !== '') {
        this.input.veh_list = ''
        this.getVehicleList()
      }
    },

    export_all(val) {
      this.export_all = val
    }

    // plate(val, oldVal) {
    //   let regex = new RegExp(/^[a-zA-Z0-9\s]+$/)
    //   if(!regex.test(val) && this.action == 'add' && val.length) this.input.plate = oldVal
    // }
  },

  created() {
    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''

    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        this.actor = res.data.message.data
        // if(this.actor.privilege >= 4) {
        //   this.ownerFilterList.push({ value: this.actor.id, label: this.actor.username })
        //   this.exportData.username = { value: this.actor.id, label: this.actor.username }
        // }
        if (this.actor.privilege <= 3)
          this.searchableList.push({ value: 'sn', label: 'Serial Number' })

        if (this.actor.privilege >= 4) this.initTable()

        this.user_special_limit_access.map((item) => {
          if (item === this.actor.username) {
            this.is_limit_access = true
          }
        })

        this.getLimitCameraList()
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })

    this.getGpsList()
    this.getBranchList()
    this.getVehicleTypeList()
    this.getVehicleBrandList()
  },

  mounted() {
    this.client_ip = JSON.parse(localStorage.getItem('client_ip'))
  },

  methods: {
    indexMethod(index) {
      return (this.page - 1) * this.per_page + (index + 1)
    },

    search() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.page = 1
        this.initTable()
      }, 800)
    },

    updatePerPage(n) {
      this.per_page = n
      this.initTable()
    },

    reset() {
      Object.keys(this.input).map((item) => {
        this.input[item] = ''
      })
    },

    getGpsList() {
      this.$http
        .get(`${this.$api.endpoint}/gps_type/select`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.gpsList = res.data.message.data
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    getVehicleBrandList() {
      this.$http
        .get(`${this.$api.endpoint}/vehicle_brand/select`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.vehicleBrandList = res.data.message.data
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    getVehicleTypeList() {
      this.$http
        .get(`${this.$api.endpoint}/vehicle_type/select`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.vehicleTypeList = res.data.message.data
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    getVehicleList(id_vehicle = '') {
      if (this.input.veh_brand == '' || this.input.veh_type == '')
        this.vehicleList = []
      else {
        this.$http
          .get(`${this.$api.endpoint}/vehicle_list/select`, {
            headers: {
              Authorization: `Bearer ${this.token}`
            },
            params: {
              brand: this.input.veh_brand ? this.input.veh_brand.value : '',
              type: this.input.veh_type ? this.input.veh_type.value : ''
            }
          })
          .then((res) => {
            this.vehicleList = res.data.message.data

            if (id_vehicle != '') {
              this.input.veh_list = this.vehicleList.find((item) => {
                return item.value === id_vehicle
              })
            }
          })
          .catch((error) => {
            this.$gf.httpErrorHandler(error)
          })
      }
    },

    getBranchList() {
      this.$http
        .get(`${this.$api.endpoint}/branch/select`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.branchList = res.data.message.data
          if (this.actor.privilege >= 3) {
            this.input.branch = this.branchList.find((item) => {
              return item.value === this.actor.branch
            })

            if (this.actor.privilege == 3) {
              this.filter.branch = this.branchList.find((item) => {
                return item.value === this.actor.branch
              })
            }
          }
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    getOwnerList() {
      this.$http
        .get(`${this.$api.endpoint}/user/owner`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          },
          params: {
            branch: this.branch
          }
        })
        .then((res) => {
          this.ownerList = res.data.message.data
          if (this.tempOwner) {
            this.input.owner = this.ownerList.find((item) => {
              return item.value === this.tempOwner
            })
          }

          // if(this.actor.privilege > 3) this.input.owner = this.ownerList.find(item => {
          //   return item.value === this.actor.id
          // })
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    getTechnicianList() {
      if (this.branch !== '') {
        this.$http
          .get(`${this.$api.endpoint}/technician/select/${this.branch}`, {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          })
          .then((res) => {
            this.technicianList = res.data.message.data

            if (this.tempTechnician) {
              this.input.technician = this.technicianList.find((item) => {
                return item.value === this.tempTechnician
              })
            }
          })
          .catch((error) => {
            this.$gf.httpErrorHandler(error)
          })
      }
    },

    getSalesList() {
      if (this.branch !== '') {
        this.$http
          .get(`${this.$api.endpoint}/sales/select/${this.branch}`, {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          })
          .then((res) => {
            this.salesList = res.data.message.data

            if (this.tempSales) {
              this.input.sales_id = this.salesList.find((item) => {
                return item.value === this.tempSales
              })
            }
          })
          .catch((error) => {
            this.$gf.httpErrorHandler(error)
          })
      }
    },

    searchOwner(search) {
      if (search.length >= 3) {
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }

        this.timer = setTimeout(() => {
          this.$http
            .get(`${this.$api.endpoint}/user/owner`, {
              headers: {
                Authorization: `Bearer ${this.token}`
              },
              params: {
                branch: this.actor.privilege >= 3 ? this.actor.branch : '',
                search: search
              }
            })
            .then((res) => {
              this.ownerFilterList = res.data.message.data
            })
            .catch((error) => {
              this.$gf.httpErrorHandler(error)
            })
        }, 1000)
      } else {
        this.ownerFilterList = []
      }
    },

    getVehicleIcon() {
      this.$http
        .get(`${this.$api.endpoint}/icon/select/${this.veh_type}`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.iconList = res.data.message.data
          if (this.action == 'add') this.input.icon = this.iconList[0]
          // else if(this.action == 'edit') {
          else {
            if (
              this.iconList.find((item) => item.value == this.tempIcon) !=
              'undefined'
            )
              this.input.icon = this.iconList.find(
                (item) => item.value == this.tempIcon
              )
            else this.input.icon = this.iconList[0]
          }
          // this.input.icon = this.action == 'edit' ?  : this.iconList[0]
        })
    },

    isTempIcon(icon) {
      return icon.value == this.tempIcon
    },

    initTable() {
      this.data = []
      this.loading = true

      this.$http
        .get(`${this.$api.endpoint}/gps/datatable`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          },
          params: {
            page: this.page,
            per_page: this.per_page,
            search: this.keyword,

            branch_id: this.filter.branch ? this.filter.branch.value : '',
            gps_type: this.filter.gps_type ? this.filter.gps_type.value : '',
            veh_type: this.filter.veh_type ? this.filter.veh_type.value : '',
            owner: this.filter.owner ? this.filter.owner.value : '',
            rebate_for: this.filter.rebate ? this.filter.rebate.value : '',
            key_search: this.key_search ? this.key_search.value : ''
          }
        })
        .then((res) => {
          this.row_total = res.data.message.total
          this.data = res.data.message.data
          this.loading = false

          this.$vs.loading.close(`#btnSearch > .con-vs-loading`)
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)

          this.$vs.loading.close(`#btnSearch > .con-vs-loading`)
        })
    },

    add() {
      if (this.action !== 'add') {
        this.reset()
        this.isChangeGsm = false
        this.isChangePlate = false
      }
      this.action = 'add'
      this.popupTitle = 'Add Vehicle'
      this.showPopup = true

      if (this.actor.privilege >= 3)
        this.input.branch = this.branchList.find((item) => {
          return item.value === this.actor.branch
        })

      if (this.actor.privilege == 2)
        this.input.branch = this.branchList.find((item) => {
          return item.value === this.actor.branch
        })
    },

    edit(id) {
      this.tempId = id
      this.action = 'edit'
      this.popupTitle = 'Edit Vehicle'

      this.isChangePlate = false
      this.isChangeGsm = false

      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#editBtn' + id,
        scale: 0.45
      })

      this.$http
        .get(`${this.$api.endpoint}/gps/detail/${id}`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          const data = res.data.message.data
          this.tempOwner = data.owner
          this.tempTechnician = data.technician
          this.tempSales = data.sales_id
          this.tempIcon = data.icon.id

          this.input.imei = data.imei
          this.input.gsm_no = data.gsm_no
          this.input.plate = data.plate
          this.input.device_name = data.device_name
          this.input.note = data.note

          this.input.owner = ''
          this.input.technician = ''
          this.input.sales_id = ''

          // this.input.icon = data.icon ? { value: data.icon.id, parking: `${this.image_source}/${data.icon.parking}`, label: data.icon.name, acc_on: `${this.image_source}/${data.icon.acc_on}`, lost: `${this.image_source}/${data.icon.lost}`, alarm: `${this.image_source}/${data.icon.alarm}` } : ''

          this.input.gps_type = this.gpsList.find((item) => {
            return item.value === data.gps_type
          })

          this.input.veh_type = this.vehicleTypeList.find((item) => {
            return item.value === data.veh_type
          })

          this.input.branch = this.branchList.find((item) => {
            return item.value === data.owner_branch
          })

          this.input.veh_brand = this.vehicleBrandList.find((item) => {
            return item.value === data.veh_brand
          })

          this.getOwnerList()
          this.getTechnicianList()
          this.getVehicleList(data.veh_list)

          this.input.year = data.year
          this.input.nomesin = data.nomesin
          this.input.norangka = data.norangka
          this.input.stnk = data.stnk
          // this.input.icon = data.icon
          this.input.guarantee = data.guarantee
          this.input.speed_limit = data.speed_limit
          this.input.driver_name = data.driver_name
          this.input.kir = data.kir

          this.$vs.loading.close(`#editBtn${id} > .con-vs-loading`)
          this.showPopup = true
        })
    },

    detail(id) {
      this.tempId = id
      this.action = 'detail'
      this.popupTitle = 'Detail Vehicle'

      this.isChangePlate = false
      this.isChangeGsm = false

      this.$http
        .get(`${this.$api.endpoint}/gps/detail/${id}`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          const data = res.data.message.data
          this.tempOwner = data.owner
          this.tempTechnician = data.technician
          this.tempSales = data.sales_id
          this.tempIcon = data.icon.id

          this.input.imei = data.imei
          this.input.gsm_no = data.gsm_no
          this.input.plate = data.plate
          this.input.device_name = data.device_name
          this.input.battery = data.battery + '%'
          this.input.gsm_signal = data.gsm_signal
          this.input.expired_date = data.expired_gsm
          this.input.register_date = data.register_date

          this.input.owner = ''
          this.input.technician = ''
          this.input.sales_id = ''

          this.input.gps_type = this.gpsList.find((item) => {
            return item.value === data.gps_type
          })

          this.input.veh_type = this.vehicleTypeList.find((item) => {
            return item.value === data.veh_type
          })

          this.input.branch = this.branchList.find((item) => {
            return item.value === data.owner_branch
          })

          this.getOwnerList()
          this.getTechnicianList()

          this.input.year = data.year
          this.input.nomesin = data.nomesin
          this.input.norangka = data.norangka
          this.input.stnk = data.stnk
          this.input.guarantee = data.guarantee
          this.input.speed_limit = data.speed_limit
          this.input.lifetime_warranty = data.lifetime_warranty
          this.input.driver_name = data.driver_name
          this.input.kir = data.kir
          this.input.limit_stream = this.convertTime(data.limit_live)
          this.input.gps_code = data._gps_type.code
          this.input.total_camera = data.total_camera

          // this.input.icon = data.icon ? { value: data.icon.id, parking: `${this.image_source}/${data.icon.parking}`, label: data.icon.name, acc_on: `${this.image_source}/${data.icon.acc_on}`, lost: `${this.image_source}/${data.icon.lost}`, alarm: `${this.image_source}/${data.icon.alarm}` } : ''

          this.$vs.loading.close(`#editBtn${id} > .con-vs-loading`)
          this.showPopup = true
        })
    },

    share(id) {
      this.tempId = id
      this.action = 'share'

      this.shareLocPopup = true

      Object.keys(this.shareData).map((item) => {
        if (item == 'email') this.shareData[item] = []
        else this.shareData[item] = ''
      })

      this.isShare = false
    },

    doExport() {
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#exportBtn',
        scale: 0.45
      })

      this.exportLoading = true

      this.$http
        .get(`${this.$api.endpoint}/gps/export`, {
          responseType: 'blob',
          params: {
            owner: this.exportData.username
              ? this.exportData.username.value
              : '',
            export_all: this.export_all
          },

          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.exportLoading = false
          this.$vs.loading.close(`#exportBtn > .con-vs-loading`)

          let filename =
            this.export_all != true
              ? `Vehicle-list (${this.exportData.username.label}).xlsx`
              : `Vehicle-list ( All Vehicle ).xlsx`
          FileDownload(res.data, filename)
        })
        .catch((error) => {
          this.exportLoading = false
          this.$vs.loading.close(`#exportBtn > .con-vs-loading`)
          this.$gf.httpErrorHandler(error)
        })
    },

    sync(index, gsm_no) {
      this.$vs.loading({
        background: 'warning',
        color: '#fff',
        container: `#syncBtn${index}`,
        scale: 0.3
      })

      this.$http
        .post(
          `${this.$api.endpoint}/gps/sync`,
          {
            gsm_no: gsm_no
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.$vs.loading.close(`#syncBtn${index} > .con-vs-loading`)

          this.data[index].expired_gsm = res.data.message

          this.$vs.notify({
            title: 'Thank You',
            text: 'Expired GSM sync Successfully',
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.$vs.loading.close(`#syncBtn${index} > .con-vs-loading`)
          this.$gf.httpErrorHandler(error)
        })
    },

    shareLoc() {
      let emails = []
      this.shareData.email.map((item) => {
        emails.push(item.value)
      })

      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#createLink',
        scale: 0.45
      })

      this.$http
        .post(
          `${this.$api.endpoint}/share_location/add`,
          {
            name: this.shareData.name,
            email: emails,
            expiration: this.shareData.time.value,
            imei: this.tempId
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.$vs.loading.close('#createLink > .con-vs-loading')

          this.notify = res.data.message.split('_').join(' ')
          this.isShare = true

          const data = res.data.data
          this.shareData.url = data.url

          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })

          // this.$router.push({ path: '/shared-location'})
        })
        .catch((error) => {
          this.$vs.loading.close('#createLink > .con-vs-loading')
          this.$gf.httpErrorHandler(error)
        })
    },

    shareWA() {
      var str = this.shareData.phone

      let fc = str.substr(0, 2)
      let lc = str.substr(2)

      let phone = fc.replace('0', '62') + lc

      let url = this.shareData.url

      window.open(`https://api.whatsapp.com/send?phone=${phone}&text=${url}`)
    },

    change_unit(imei) {
      if (this.action !== 'add') this.reset()

      this.input.imei = imei
      this.changeUnitPopup = true
    },

    submitChangeUnit() {
      this.isSubmit = true
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: '#submitBtnChangeUnit',
        scale: 0.45
      })

      this.$http
        .post(
          `${this.$api.endpoint}/gps/change_unit`,
          {
            old_imei: this.input.imei,
            new_imei: this.input.new_imei,
            type: this.input.type ? this.input.type.value : null,
            description: this.input.description,
            client_ip: this.client_ip
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.isSubmit = false
          this.$vs.loading.close('#submitBtnChangeUnit > .con-vs-loading')

          this.notify = res.data.message.split('_').join(' ')

          this.changeUnitPopup = false
          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })

          this.initTable()
        })
        .catch((error) => {
          this.isSubmit = false
          this.$vs.loading.close('#submitBtnChangeUnit > .con-vs-loading')
          this.$gf.httpErrorHandler(error)
        })
    },

    searchTarget(search) {
      if (search.length >= 3) {
        this.timer = setTimeout(() => {
          this.$http
            .get(`${this.$api.endpoint}/gps/search-list?keyword=${search}`, {
              headers: {
                Authorization: `Bearer ${this.token}`
              }
            })
            .then((res) => {
              this.swapTargetList = res.data.message.data
            })
            .catch((error) => {
              this.$gf.httpErrorHandler(error)
            })
        }, 800)
      } else {
        this.swapTargetList = []
      }
    },

    swapGsm(item) {
      this.swapData.imei = item.imei
      this.swapData.text = `${item.imei} - ${item.plate} - ${item.gsm_no}`
      this.swapSimcardPopup = true
    },

    doSwap() {
      this.swapLoading = true
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: '#swapBtn',
        scale: 0.45
      })

      this.$http
        .post(`${this.$api.endpoint}/gps/swap`, {
          ...this.swapData,
          target_imei: this.swapData.target_imei.value,
          client_ip: this.client_ip
        })
        .then((res) => {
          this.swapLoading = false
          this.$vs.loading.close('#swapBtn > .con-vs-loading')

          this.notify = res.data.message.split('_').join(' ')

          this.changeUnitPopup = false
          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
          this.swapSimcardPopup = false
          for (let i in this.swapData) {
            this.swapData[i] = ''
          }
          this.initTable()
        })
        .catch((err) => {
          this.swapLoading = false
          this.$vs.loading.close('#swapBtn > .con-vs-loading')
          this.$gf.httpErrorHandler(err)
        })
    },

    ChangePlate() {
      this.isChangePlate = !this.isChangePlate
    },

    ChangeGsm() {
      this.isChangeGsm = !this.isChangeGsm
    },

    del(id) {
      this.tempId = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Delete GPS`,
        text: 'Are you sure want to Delete this Vehicle ?',
        accept: this.confirmDelete
      })
    },

    confirmDelete() {
      this.$http
        .post(
          `${this.$api.endpoint}/gps/delete/${this.tempId}`,
          {
            client_ip: this.client_ip
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.notify = res.data.message.split('_').join(' ')

          this.initTable()

          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    reset_mileage(imei, mileage_before) {
      this.resetMileageData.imei = imei
      this.resetMileageData.mileage_before = mileage_before
      this.resetMileageData.mileage = ''
      this.resetMileagePopup = true
    },

    act_reset_mileage() {
      this.resetLoading = true
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: '#resetMileage',
        scale: 0.45
      })

      this.$http
        .post(`${this.$api.endpoint}/gps/reset_mileage`, {
          imei: this.resetMileageData.imei,
          mileage_before: this.resetMileageData.mileage_before,
          mileage: this.resetMileageData.mileage,
          client_ip: this.client_ip
        })
        .then((res) => {
          this.resetLoading = false
          this.$vs.loading.close('#resetMileage > .con-vs-loading')

          this.notify = res.data.message.split('_').join(' ')

          this.resetMileagePopup = false
          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })

          this.initTable()
        })
        .catch((err) => {
          this.resetLoading = false
          this.$vs.loading.close('#resetMileage > .con-vs-loading')
          this.$gf.httpErrorHandler(err)
        })
    },

    submit() {
      this.loading = true
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: '#submitBtn',
        scale: 0.45
      })

      let url =
        this.action === 'add'
          ? `${this.$api.endpoint}/gps/add`
          : `${this.$api.endpoint}/gps/update/${this.tempId}`
      this.$http
        .post(
          url,
          {
            imei: this.input.imei,
            gsm_no: this.input.gsm_no,
            plate: this.input.plate,
            device_name: this.input.device_name,
            gps_type: this.input.gps_type.value,
            veh_type: this.input.veh_type.value,
            branch_id: this.input.branch.value,
            owner: this.input.owner.value,
            technician: this.input.technician
              ? this.input.technician.value
              : '',
            sales_id: this.input.sales_id ? this.input.sales_id.value : '',
            year: this.input.year,
            nomesin: this.input.nomesin,
            norangka: this.input.norangka,
            stnk: this.input.stnk,
            icon: this.input.icon ? this.input.icon.value : '',
            speed_limit: this.input.speed_limit,
            descriptionPlate: this.input.descriptionPlate,
            descriptionGsm: this.input.descriptionGsm,
            simcard_change_type: this.input.simcard_change_type,
            driver_name: this.input.driver_name,
            veh_brand: this.input.veh_brand ? this.input.veh_brand.value : '',
            veh_list: this.input.veh_list ? this.input.veh_list.value : '',
            kir: this.input.kir ? this.input.kir : null,
            client_ip: this.client_ip,
            note2: this.input.note
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.loading = false
          this.$vs.loading.close('#submitBtn > .con-vs-loading')

          this.notify = res.data.message.split('_').join(' ')

          this.showPopup = false
          this.initTable()
          this.reset()

          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.loading = false
          this.$vs.loading.close('#submitBtn > .con-vs-loading')
          this.$gf.httpErrorHandler(error)
        })
    },

    setWatermark(index, imei, plate) {
      this.$vs.loading({
        background: 'warning',
        color: '#fff',
        container: `#setWtrBtn${index}`,
        scale: 0.3
      })

      this.$http
        .post(
          `${this.$api.endpoint}/dashcam/setup_watermark`,
          {
            imei: imei,
            cmd_content: `CAR,SUPERSPRING X40,${plate},`
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.$vs.loading.close(`#setWtrBtn${index} > .con-vs-loading`)

          this.$vs.notify({
            title: 'Thank You',
            text: res.data.message,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.$vs.loading.close(`#syncBtn${index} > .con-vs-loading`)
          this.$gf.httpErrorHandler(error)
        })
    },

    getLimitCameraList() {
      this.$http
        .get(`${this.$api.endpoint}/gps/list_limit_camera`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.limitCameraList = res.data.message.data

          if (this.is_limit_access) {
            let temp_camera_list = this.limitCameraList.find((e) => {
              return e.value == 600
            })

            this.limitCameraList = [temp_camera_list]
          }
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    limit_camera(item, index) {
      this.imei_limit = item.imei
      this.imei_index_limit = index
      this.selected_limit = this.is_limit_access
        ? { label: '10 menit/bulan', value: 600, id: 6 }
        : { label: '200 menit/bulan', value: 12000, id: 1 }
    },

    confirmLimitCamera() {
      this.$vs.loading({
        background: 'warning',
        color: '#fff',
        container: '#limitCameraBtn_' + this.imei_index_limit,
        scale: 0.45
      })

      this.$http
        .post(
          `${this.$api.endpoint}/gps/setup_limit/${this.imei_limit}`,
          {
            limit_live: this.selected_limit ? this.selected_limit.value : '',
            limit_id: this.selected_limit ? this.selected_limit.id : ''
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.$vs.loading.close(
            `#limitCameraBtn_${this.imei_index_limit} > .con-vs-loading`
          )

          this.notify = res.data.message.split('_').join(' ')
          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.$vs.loading.close(
            `#limitCameraBtn_${this.imei_index_limit} > .con-vs-loading`
          )

          this.$gf.httpErrorHandler(error)
        })
    },

    total_camera(item, index) {
      this.imei_total_camera = item.imei
      this.imei_index_total_camera = index
      this.selected_total_camera =
        item.total_camera != null
          ? this.totalCameraList.find((val) => {
              return val.value === item.total_camera
            })
          : { label: '1 Camera', value: 1 }
    },

    confirmTotalCamera() {
      this.$vs.loading({
        background: 'warning',
        color: '#fff',
        container: '#totalCameraBtn_' + this.imei_index_total_camera,
        scale: 0.45
      })

      this.$http
        .post(
          `${this.$api.endpoint}/gps/update_total_camera/${this.imei_total_camera}`,
          {
            total_camera: this.selected_total_camera
              ? this.selected_total_camera.value
              : ''
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.$vs.loading.close(
            `#totalCameraBtn_${this.imei_index_total_camera} > .con-vs-loading`
          )

          this.notify = res.data.message.split('_').join(' ')
          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.$vs.loading.close(
            `#totalCameraBtn_${this.imei_index_total_camera} > .con-vs-loading`
          )

          this.$gf.httpErrorHandler(error)
        })
    },

    convertTime(totalSec) {
      const hour = Math.floor(totalSec / 3600)
      const minute = Math.floor((totalSec % 3600) / 60)
      const second = totalSec % 60
      const hours = hour < 10 ? '0' + hour : hour
      const minutes = minute < 10 ? '0' + minute : minute
      const seconds = second < 10 ? '0' + second : second

      const time = hours + ' Hr ' + minutes + ' Min ' + seconds + ' Sec '
      return time
    },

    search_proses(e) {
      if (e !== undefined) {
        if (e.key === 'Enter') {
          if (this.loading) {
            this.$vs.notify({
              title: 'Please wait',
              text: 'The data is being processed',
              color: 'warning',
              position: 'top-right'
            })
          } else {
            this.$vs.loading({
              background: 'primary',
              color: '#fff',
              container: '#btnSearch',
              scale: 0.45
            })
            this.initTable()
          }
        }
      } else {
        if (this.loading) {
          this.$vs.notify({
            title: 'Please wait',
            text: 'The data is being processed',
            color: 'warning',
            position: 'top-right'
          })
        } else {
          this.$vs.loading({
            background: 'primary',
            color: '#fff',
            container: '#btnSearch',
            scale: 0.45
          })
          this.initTable()
        }
      }
    }
  }
}
</script>
